import React from 'react';
import { Link } from 'react-router-dom';

export default function LinkStyled({ className, to, href, children, isActive, underlineFromCenter }) {
  const computedClasses = `${ underlineFromCenter && 'link-styled-simple--underline-from-center'} ${ isActive && 'link-styled-simple--active'} ${ className || '' }`
  const linkStyledClasses = `link-styled-simple c-black c-red:h trs-c-0.3s-eio dib fz14@sm fz16 lh1.25 fw700 tdn p0 curp posr ff-gr ${computedClasses}`;

  return to ? (
    isActive ?
    <Link
      className={linkStyledClasses}
      to={to}
      aria-current="page"
    >
    { children }
    </Link>
    :
    <Link
      className={linkStyledClasses}
      to={to}
    >
    { children }
    </Link>
  )
  : href ? (
    <a
      className={linkStyledClasses}
      href={href}
    >
    { children }
    </a>
    )
  : (
    <span
      className={linkStyledClasses}
    >
    { children }
    </span>
    )
}